import ReactDOM from "react-dom/client";
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navband from "./components/navband";
import Navigation from "./components/navigation";
import Footer from "./components/footer";
import Home from "./pages/Home";
import About from "./pages/AboutAcerHealth";
import Contact from "./pages/Contact";
import Solution from "./pages/Solutions";
import RCM from "./pages/Services_RCM";
import MBS from "./pages/Services_MedicalBilling";
import MBOS from "./pages/Services_MBSoutsourcing.js"
import Consultancy from './pages/Services_Consultancy';
import Credentialing from './pages/Services_Credentialing';
import StartPractice from './pages/Service_StartPracticeService';
import Contract from './pages/Services_ContractCompliance';
import Denailserv from './pages/Servicves_Denail_desc.js';
import MedicalcodingServ from './pages/Service-Medicalcoding.js';
import Blogs from './pages/Blogs';
import Blogs1 from './pages/Blogs/Whats_the_Difference_Between_Medical_Billing_and_Credentialing';
import Blogs2 from './pages/Blogs/outsourcing-medical-billing-benefits';
import Blogs3 from './pages/Blogs/Maximize_Revenue_and_Minimize_Hassles_with_AcerHealth_Experts_Medical_Billing_Services';
import Blogs4 from './pages/Blogs/Unveiling_the_Core_Concepts_of_Electronic_Health_Records_EHRs';
import Blogs5 from './pages/Blogs/revenue-cycle-management-tips';
import Blogs6 from './pages/Blogs/How_to_Accelerate_claims_processing_technology';
import Blogs7 from './pages/Blogs/Obtain_Billing_Services_from_the_Best_Medical_Billing_Company';
import Blogs8 from './pages/Blogs/Techniques_to_Increase_Patient_Engagement';
import Blogs9 from './pages/Blogs/How_to_Prevent_Medical_Billing_Rejections';
import Blogs10 from './pages/Blogs/What_Does_Billing_Mean_to_Patients';
import Blogs11 from './pages/Blogs/Challenges_in_managing_the_healthcare_revenue_cycle';
import Blogs12 from './pages/Blogs/medical-billing-techniques';
import Blogs13 from './pages/Blogs/Medical_Billing_Trends_to_Watch_in_2023';
import Blogs14 from './pages/Blogs/rcm-vs-health-informatics';
import Blogs15 from './pages/Blogs/Management_of_the_Healthcare_Revenue_Cycle';
import Blogs16 from './pages/Blogs/Details_about_Patients _is_protected_by_AcerHealth';
import Blogs17 from './pages/Blogs/De_Identified_Health_Information';
import Blogs18 from './pages/Blogs/Potentially_how_can_we_increase_your_Revenues';
import Blogs19 from './pages/Blogs/medical-billing-trends-2025';
import Blogs20 from './pages/Blogs/proven_ways_to_reduce_medical_billing_caim_denails';
import Blogs21 from './pages/Blogs/medical_billing_for_small_practices';
import Blogs22 from './pages/Blogs/Questions_to_ask_Before_Outsoursing';
import Blogs23 from './pages/Blogs/Ultimate-Guide-to-Medical-Billing';
import Blogs24 from './pages/Blogs/Denile-management-in-medicale-billing';
import Blogs25 from './pages/Blogs/What-Are_Medical_Consultancy_Services.js';
import Blogs26 from './pages/Blogs/Comprehensive-Guideto-Medicabilling-service.js';
import Blogs27 from './pages/Blogs/Revenue-Cycle-managment-explianed.js';
import Blogs28 from './pages/Blogs/TypesOf-MedicalBilling-impactRCM.js';
import Blogs29 from './pages/Blogs/Complete-BillingAndCoding-Services.js';
import Blogs30 from './pages/Blogs/Feeling_Billing_burden.js';
import Blogs31 from './pages/Blogs/Medicalbilling-coding.js';
import Blogs32 from './pages/Blogs/Medical-CodingServices-Usa.js';
import Blogs33 from './pages/Blogs/7_Common_Reasons_for_Claim_Denials_Prevent_Them.js';
import Blogs34 from './pages/Blogs/What_is_MedicalBilling_process.js';
import Blogs35 from './pages/Blogs/RevenueCycle_Vs_MedicalBilling.js';
import Blogs36 from './pages/Blogs/What-is-Medicalbilling-simple-guide.js';
import Blogs37 from './pages/Blogs/Top20-medicalBilling-denailCodes.js';
import Blogs38 from './pages/Blogs/RCM_in_HealthCareIndustry.js';
import Blogs39 from './pages/Blogs/MedicalBilling_Services.js';
import Blogs40 from './pages/Blogs/Inhouse-VS-OutsourcedMBS.js';
import Blogs41 from './pages/Blogs/Top-RCMChallengesandKPIS.js';
import Blogs42 from './pages/Blogs/How-does-MB-OutsourcingWorks.js';
import Blogs43 from './pages/Blogs/UpstramClaim-Scrubbing.js';


import LowercaseRedirect from "./components/LowercaseRedirect";
import Testimonials from './pages/Testimonials';
import Eligibility from './pages/Tech_Eligibility';
import PatientPayment from './pages/Tech_PatientPayment';
import SmartReport from './pages/Tech_SmartReport';
import PreAuth from './pages/Tech_PreAuthorization';
import Cardologyspeciality from "./pages/Specialist_cardologyInfo";
import OldBlogRedirect from './components/redirectpage'; // import this
import Testimonial from "./pages/Testimonials";


export default function App() {
   return (
      <Router>
         {/* Global lowercase redirect */}
         <LowercaseRedirect />
         <Navband />
         <Navigation />
         <Routes>
            <Route path="/" exact element={<Home />} />
            {/* <Route path="blogs/*" element={<Blogs />} /> */}
            <Route path="/about-us" element={<About />} />
            <Route path="/contact-us" element={<Contact />} />
            <Route path="/services/revenue-cycle-management" element={<RCM />} />
            <Route path="/services/medical-billing-services" element={<MBS />} />
            <Route path="/services/medical-billing-outsourcing-services-usa" element={<MBOS />} />
            <Route path="/consultancy-services" element={<Navigate to="/services/medical-consultancy-services" replace />} />
            <Route path="/services/medical-consultancy-services" element={<Consultancy />} />

            <Route
               path="/wp_site/medical-billing-services-patient-balances" element={<Navigate to="/services/medical-billing-services" replace />}
            />
            <Route path="/services/medical-billing-services" element={<MBS />} />
            <Route path="/services/medical-billing-and-credentialing" element={<Credentialing />} />
            <Route path="/services/set-up-practice" element={<StartPractice />} />
            <Route path="/services/contract-compliance" element={<Contract />} />
            <Route path="/medical-billing-blogs" element={<Blogs />} />
            <Route path="/services/denial-management-services" element={<Denailserv />} />

            {/* Main path (new shorter/custom URL) */}
            <Route path="/services/medical-coding-services" element={<MedicalcodingServ />} />

            {/* Optional: redirect old long path to new one */}
            <Route
               path="/services/Medical-Coding-Services"
               element={<Navigate to={<MedicalcodingServ />} replace />}
            />
            <Route path="/blog/whats_the_difference_between_medical_billing_and_credentialing" element={<OldBlogRedirect />} />
            <Route path="/blog/medical-billing-vs-credentialing" element={<Blogs1 />} />
            <Route path="/blog/choosing_to_outsource_your_medical_billing_is_a_smart_decision" element={<OldBlogRedirect />} />
            <Route path="/blog/outsourcing-medical-billing-benefits" element={<Blogs2 />} />
            <Route path="/blog/maximize_revenue_and_minimize_hassles_with_acerhealth_experts_medical_billing_services" element={<OldBlogRedirect />} />
            <Route path="/blog/medical-billing-to-boost-revenue" element={<Blogs3 />} />
            <Route path="/blog/unveiling_the_core_concepts_of_electronic_health_records_EHRs" element={<OldBlogRedirect />} />
            <Route path="/blog/electronic-health-records-basics" element={<Blogs4 />} />

            <Route path="/blog/best_practices_for_improving_revenue_cycle_management" element={<OldBlogRedirect />} />
            <Route path="/blog/revenue-cycle-management-tips" element={<Blogs5 />} />
            <Route path="/blog/how_to_accelerate_claims_processing_technology" element={<OldBlogRedirect />} />
            <Route path="/blog/claims-processing-technology" element={<Blogs6 />} />
            <Route path="/blog/obtain_billing_services_from_the_best_medical_billing_company" element={<OldBlogRedirect />} />
            <Route path="/blog/best-medical-billing-company" element={<Blogs7 />} />
            <Route
               path="/blogs/what_does_billing_mean_to_patients"
               element={<Navigate to="/blogs/what-billing-means-for-patients" replace />}
            />
            <Route
               path="/blogs/what-billing-means-for-patients"
               element={<Blogs10 />}
            />
            <Route path="/blog/Challenges_in_managing_the_healthcare_revenue_cycle" element={<OldBlogRedirect />} />
            <Route path="/blog/healthcare-revenue-cycle-challenges" element={<Blogs11 />} />

            <Route path="/Testimonials" element={<Testimonials />} />
            <Route path="/technologies/patient-balance-estimator" element={<Eligibility />} />
            <Route path="/technologies/patient-statements-payment-portal" element={<PatientPayment />} />
            <Route path="/technologies/practice-analytics" element={<SmartReport />} />
            <Route path="/technologies/patient-eligibility-verification" element={<PreAuth />} />
            <Route path="/medical-billing-specialities" element={<Solution />} />
            <Route path="/who-we-serve#Cardology_speciality" element={<Cardologyspeciality />} />
            <Route path="/who-we-serve#Pediatrics" element={<Cardologyspeciality />} />
            <Route path="/who-we-serve#Psychiatry" element={<Cardologyspeciality />} />
            <Route path="/who-we-serve#Dermatology" element={<Cardologyspeciality />} />
            <Route path="/who-we-serve#Internal_Medicine" element={<Cardologyspeciality />} />
            <Route path="/who-we-serve#Plastic_Surgery" element={<Cardologyspeciality />} />
            <Route path="/who-we-serve#Surgery" element={<Cardologyspeciality />} />
            <Route path="/who-we-serve#Rheumatology" element={<Cardologyspeciality />} />
            <Route path="/who-we-serve#Infection_Diseases" element={<Cardologyspeciality />} />
            <Route path="/who-we-serve#Gynecology" element={<Cardologyspeciality />} />
            <Route path="/who-we-serve#Urology" element={<Cardologyspeciality />} />

            <Route path="/who-we-serve" element={<Cardologyspeciality />} />
            <Route
               path="/Cardologyspeciality"
               element={<Navigate to={<Cardologyspeciality />} replace />}
            />
            <Route path="/blog/medical_billing_trends_to_watch_in_2023_24" element={<OldBlogRedirect />} />
            <Route path="/blog/medical-billing-trends-2023-24" element={<Blogs13 />} />

            <Route path="/blog/comparing_healthcare_revenue_cycle_management_vs_health_informatics" element={<OldBlogRedirect />} />
            <Route path="/blog/rcm-vs-health-informatics" element={<Blogs14 />} />

            <Route path="/blog/management_of_the_healthcare_revenue_cycle" element={<OldBlogRedirect />} />
            <Route path="/blog/healthcare-revenue-cycle-management" element={<Blogs15 />} />

            <Route path="/blog/details_about_patients_is_protected_by_acerhealth" element={<OldBlogRedirect />} />
            <Route path="/blog/patient-data-protection" element={<Blogs16 />} />

            <Route path="/blog/de_identified_health_information" element={<OldBlogRedirect />} />
            <Route path="/blog/increase-healthcare-revenue" element={<Blogs17 />} />

            <Route path="/Best_Practices_for_Improving_Revenue_Cycle_Management_AcerHealth" element={<OldBlogRedirect />} />
            <Route path="/blog/increase-healthcare-revenue" element={<Blogs17 />} />

            <Route path="/blog/potentially_how_can_we_increase_your_revenues" element={<OldBlogRedirect />} />
            <Route path="/blog/increase-healthcare-practice-revenue" element={<Blogs18 />} />

            <Route path="/blog/medical-billing-trends-2025" element={<Blogs19 />} />
            <Route path="/blog/reduce-claim-denials" element={<Blogs20 />} />
            <Route path="/blog/medical-billing-services-for-small-practices" element={<Blogs21 />} />
            {/* <Route path="/blog/outsourcing-medical-billing-questions" element={<Blogs22 />} /> */}
            <Route path="/blog/Ultimate-Guide-to-Medical-Billing" element={<Blogs23 />} />
            <Route path="/blog/denial-management-guide" element={<Blogs24 />} />
            <Route path="/blog/medical-consultancy-services-benefits" element={<Blogs25 />} />
            <Route path="/blog/medical-billing-services-guide" element={<Blogs26 />} />

            <Route path="/blog/revenue-cycle-management-explained" element={<Blogs27 />} />
            <Route path="/blog/types-of-medical-billing-and-rcm-impact" element={<Blogs28 />} />
            <Route path="/blog/complete-billing-coding-usa" element={<Blogs29 />} />
            <Route path="/blog/medical-billing-outsourcing-usa" element={<Blogs30 />} />
            <Route path="/blog/medical-billing-coding-usa" element={<Blogs31 />} />
            <Route path="/blog/medical-coding-services-usa" element={<Blogs32 />} />

            <Route path="/blog/claim-denial-reasons-usa" element={<Blogs33 />} />
            <Route path="/blog/medical-billing-process" element={<Blogs34 />} />
            <Route path="/blog/revenue-cycle-vs-medical-billing" element={<Blogs35 />} />
            <Route path="/blog/what-is-medical-billing" element={<Blogs36 />} />
            <Route path="/blog/denial-codes-in-medical-billing" element={<Blogs37 />} />
            <Route path="/blog/revenue-cycle-management-in-healthcare" element={<Blogs38 />} />
              <Route path="/blog/medical-billing-services-for-healthcare-providers" element={<Blogs39 />} />

              <Route path="/blog/in-house-vs-outsourced-medical-billing-cost-comparison" element={<Blogs40 />} />
            <Route path="/blog/revenue-cycle-management-challenges-and-kpis" element={<Blogs41 />} />
             <Route path="/blog/how-does-medical-billing-outsourcing-work" element={<Blogs42 />} />
                          <Route path="/blog/upstream-claim-scrubbing" element={<Blogs43 />} />




            <Route path="/credentialing" element={<OldBlogRedirect />} />
            <Route path="/services/medical-billing-and-credentialing" element={<Credentialing />} />
            <Route path="/testimonials.php" element={<Navigate to="/testimonials" replace />} />
            <Route path="/testimonials" element={<Testimonials />} />

            <Route path="/credentialing-services.php" element={<Navigate to="/services/medical-billing-and-credentialing" replace />} />
            <Route path="/services/medical-billing-and-credentialing" element={<Credentialing />} />
            <Route path="/blogs/de_identified_health_information" element={<OldBlogRedirect />} />
            <Route path="/blog/increase-healthcare-revenue" element={<Blogs17 />} />
            <Route path="/Eligibility" element={<OldBlogRedirect />} />
            <Route path="/technologies/patient-eligibility-verification" element={<PreAuth />} />
            <Route path="/wp_site/medical-billing-services-healthcare-services/" element={<OldBlogRedirect />} />
            <Route path="/services/medical-billing-and-credentialing" element={<Credentialing />} />

            <Route path="/covidrelief.php" element={<Navigate to="/acerhealth.com/" replace />} />
            <Route path="/acerhealth.com/" element={<Home />} />

            <Route path="/eligibility-verification" element={<OldBlogRedirect />} />
            <Route path="/technologies/patient-eligibility-verification" element={<PreAuth />} />

            <Route path="/patient-out-of-pocket-calculator" element={<OldBlogRedirect />} />
            <Route path="/technologies/patient-balance-estimator" element={<Eligibility />} />

            <Route path="/OldWebsite/contactus.php" element={<OldBlogRedirect />} />
            <Route path="/contact-us" element={< Contact />} />

            <Route path="/wp_site/medical-coding/" element={<OldBlogRedirect />} />
            <Route path="/services/medical-billing-and-credentialing" element={< Credentialing />} />

            <Route path="/free-consultation.php" element={<OldBlogRedirect />} />
            <Route path="/contact-us" element={< Contact />} />

            <Route path="/blog/outsourcing-medical-billing-benefits" element={<Blogs2 />} />
            <Route
               path="/wp_site/billing-services/"
               element={<Navigate to="/blog/outsourcing-medical-billing-benefits" replace />}
            />
            <Route path="/technologies/patient-balance-estimator" element={<Eligibility />} />

            <Route
               path="/patient-balance-estimator.php"
               element={<Navigate to="/technologies/patient-balance-estimator" replace />}
            />
            <Route path="/contact-us" element={<Contact />} />
            <Route
               path="/acerhealth.com/join-acerhealth.php"
               element={<Navigate to="/contact-us" replace />}
            />
            <Route path="/contact-us" element={<Contact />} />
            {/* Redirect from old path */}
            <Route
               path="/contact-us.php"
               element={<Navigate to="/contact-us" replace />}
            />

            <Route path="/blog/rcm-vs-health-informatics" element={<Blogs14 />} />
            <Route
               path="/blogs/comparing_healthcare_revenue_cycle_management_vs_health_informatics"
               element={<Navigate to="/blog/rcm-vs-health-informatics" replace />}
            />
            <Route path="/blog/electronic-health-records-basics" element={<Blogs4 />} />
            <Route
               path="/blogs/unveiling_the_core_concepts_of_electronic_health_records_EHRs"
               element={<Navigate to="/blog/electronic-health-records-basics" replace />}
            />
            <Route path="/blog/Ultimate-Guide-to-Medical-Billing" element={<Blogs24 />} />
            <Route
               path="/blog/medical-billing-guide"
               element={<Navigate to="/blog/Ultimate-Guide-to-Medical-Billing" replace />}
            />
            <Route path="/acerhealth.com/" element={<Home />} />
            <Route
               path="/index.html"
               element={<Navigate to="/acerhealth.com/" replace />}
            />

            <Route path="/acerhealth.com/" element={<Home />} />
            <Route
               path="/acerhealth.com/index"
               element={<Navigate to="/acerhealth.com/" replace />}
            />
            <Route path="/blog/medical-billing-vs-credentialing" element={<Blogs1 />} />
            <Route
               path="/blogs/whats_the_difference_between_medical_billing_and_credentialing"
               element={<Navigate to="/blog/medical-billing-vs-credentialing" replace />}
            />

            <Route path="/blog/electronic-health-records-basics" element={<Blogs4 />} />
            <Route
               path="/wp_site/electronic-health-records/"
               element={<Navigate to="/blog/electronic-health-records-basics" replace />}
            />
            <Route path="/blog/medical-billing-trends-2023-24" element={<Blogs13 />} />
            <Route
               path="/blogs/medical_billing_trends_to_watch_in_2023_24"
               element={<Navigate to="/blog/medical-billing-trends-2023-24" replace />}
            />
            <Route path="/blog/revenue-cycle-management-tips" element={<Blogs5 />} />
            <Route
               path="/blogs/Challenges_in_managing_the_healthcare_revenue_cycle"
               element={<Navigate to="/blog/revenue-cycle-management-tips" replace />}
            />

            <Route path="/acerhealth.com/" element={<Home />} />
            <Route
               path="/covidrelief"
               element={<Navigate to="/acerhealth.com/" replace />}
            />
            <Route path="/blog/medical-billing-trends-2025" element={<Blogs19 />} />
            <Route
               path="/blog/medical-billing-trends-2025Top"
               element={<Navigate to="/blog/medical-billing-trends-2025" replace />}
            />
            <Route path="/blog/medical-billing-services-for-small-practices" element={<Blogs21 />} />
            <Route
               path="/blog/medical-billing-services-for-small-practicesMedical"
               element={<Navigate to="/blog/medical-billing-services-for-small-practices" replace />}
            />
            <Route path="/blog/increase-healthcare-practice-revenue" element={<Blogs18 />} />
            <Route
               path="/blogs/potentially_how_can_we_increase_your_revenues"
               element={<Navigate to="/blog/increase-healthcare-practice-revenue" replace />}
            />
            <Route path="/blog/medical-billing-to-boost-revenue" element={<Blogs3 />} />
            <Route
               path="/blogs/maximize_revenue_and_minimize_hassles_with_acerhealth_experts_medical_billing_services"
               element={<Navigate to="/blog/medical-billing-to-boost-revenue" replace />}
            />
            <Route path="/services/set-up-practice" element={<StartPractice />} />
            <Route
               path="/startpractice"
               element={<Navigate to="/services/set-up-practice" replace />}
            />
            <Route path="/blog/prevent-medical-billing-rejections" element={<Blogs9 />} />
            <Route
               path="/blog/How_to_Prevent_Medical_Billing_Rejections"
               element={<Navigate to="/blog/prevent-medical-billing-rejections" replace />}
            />
            <Route path="/blog/patient-engagement-techniques" element={<Blogs8 />} />
            <Route
               path="/blogs/techniques_to_increase_patient_engagement"
               element={<Navigate to="/blog/patient-engagement-techniques" replace />}
            />
            <Route path="/blog/outsourcing-medical-billing-questions" element={<Blogs22 />} />
            <Route
               path="/blog/10-questions-before-outsourcing-medical-billing"
               element={<Navigate to="/blog/outsourcing-medical-billing-questions" replace />}
            />
            <Route path="/blog/medical-billing-trends-2025" element={<Blogs22 />} />
            <Route
               path="/blog/top-medical-billing-trends-2025"
               element={<Navigate to="/blog/medical-billing-trends-2025" replace />}
            />
            <Route path="/blog/medical-billing-techniques" element={<Blogs12 />} />
            <Route
               path="/blog/AcerHealth_medical_billing_techniques"
               element={<Navigate to="/blog/medical-billing-techniques" replace />}
            />
            <Route path="/blogs/acerhealth_medicalbilling_techniques" element={<Navigate to="/blog/medical-billing-techniques" replace />} />
            <Route path="/blog/medical-billing-techniques" element={<Blogs12 />} />

            <Route path="/blog/prevent-medical-billing-rejections" element={<Blogs9 />} />
            <Route
               path="/blogs/how_to_prevent_medical_billing_rejections"
               element={<Navigate to="/blog/prevent-medical-billing-rejections" replace />}
            />
            <Route path="/blog/patient-data-protection" element={<Blogs16 />} />
            <Route
               path="/blogs/details_about_patients_is_protected_by_acerhealth"
               element={<Navigate to="/blog/patient-data-protection" replace />}
            />
            <Route path="/blog/healthcare-revenue-cycle-challenges" element={<Blogs11 />} />
            <Route
               path="/blogs/best_practices_for_improving_revenue_cycle_management"
               element={<Navigate to="/blog/healthcare-revenue-cycle-challenges" replace />}
            />
            <Route path="/services/medical-billing-services" element={<MBS />} />
            <Route
               path="/wp_site/medical-billing/"
               element={<Navigate to="/services/medical-billing-services" replace />}
            />
            <Route path="/services/revenue-cycle-management" element={<RCM />} />
            <Route
               path="/wp_site/revenue-maximizer/"
               element={<Navigate to="/services/revenue-cycle-management" replace />}
            />
            <Route path="/services/medical-billing-services" element={<MBS />} />
            <Route
               path="/wp_site/comprehensive-medical-billing/"
               element={<Navigate to="/services/medical-billing-services" replace />}
            />
            <Route path="/services/medical-billing-services" element={<MBS />} />
            <Route
               path="/Billing_and_Collection"
               element={<Navigate to="/services/medical-billing-services" replace />}
            />
            <Route path="/services/contract-compliance" element={<Contract />} />
            <Route
               path="/contract"
               element={<Navigate to="/services/contract-compliance" replace />}
            />
            <Route path="/services/medical-billing-services" element={<MBS />} />
            <Route
               path="/wp_site/medical-billing-services-2/"
               element={<Navigate to="/services/medical-billing-services" replace />}
            />

            <Route path="/blog/medical-billing-vs-credentialing" element={<Blogs1 />} />
            <Route
               path="/Whats_the_Difference_Between_Medical_Billing_and_Credentialing"
               element={<Navigate to="/blog/medical-billing-vs-credentialing" replace />}
            />
            <Route path="/services/contract-compliance" element={<Contract />} />
            <Route
               path="/contracts-and-compliance"
               element={<Navigate to="/services/contract-compliance" replace />}
            />
            <Route path="/blog/outsourcing-medical-billing-benefits" element={<Blogs2 />} />
            <Route
               path="/Medical_Billing_Outsource.php"
               element={<Navigate to="/blog/outsourcing-medical-billing-benefits" replace />}
            />
            <Route path="/about-us" element={<About />} />
            <Route
               path="/company.php"
               element={<Navigate to="/about-us" replace />}
            />
            <Route path="/services/medical-billing-services" element={<MBS />} />
            <Route
               path="/medical-billing-services.php"
               element={<Navigate to="/services/medical-billing-services" replace />}
            />
            <Route path="/technologies/patient-statements-payment-portal" element={<PatientPayment />} />
            <Route
               path="/patient-statements-and-payment-portal.php"
               element={<Navigate to="/technologies/patient-statements-payment-portal" replace />}
            />
            <Route path="/services/medical-billing-services" element={<MBS />} />
            <Route
               path="/accredited_medical_billing"
               element={<Navigate to="/services/medical-billing-services" replace />}
            />
            <Route path="/blog/prevent-medical-billing-rejections" element={<Blogs9 />} />
            <Route
               path="/How_to_Prevent_Medical_Billing_Rejections"
               element={<Navigate to="/blog/prevent-medical-billing-rejections" replace />}
            />
            <Route path="/testimonials" element={<Testimonial />} />
            <Route
               path="/mbs"
               element={<Navigate to="/testimonials" replace />}
            />
            <Route path="/blog/medical-billing-techniques" element={<Blogs12 />} />
            <Route
               path="/AcerHealth_medicalbilling_techniques"
               element={<Navigate to="/blog/medical-billing-techniques" replace />}
            />
            <Route path="/contact-us" element={<Contact />} />
            <Route
               path="/join-acerhealth.php"
               element={<Navigate to="/contact-us" replace />}
            />
            <Route path="/contact-us" element={<Contact />} />
            <Route
               path="/contact-us?fbclid=IwZXh0bgNhZW0CMTAAYnJpZBExbnNQdW1oWFlDdDFiSU9URwEeS58var_353Id3PV8Gn3S8WfH162W-prOxGN3HT8wxF3ZllCfHl2JAaVwcUc_aem_3VQMeAQnLSCvMC1uFjf8wQ"
               element={<Navigate to="/contact-us" replace />}
            />
            <Route path="/who-we-serve" element={<Cardologyspeciality />} />
            <Route
               path="/wp_site/physician-credentialing/"
               element={<Navigate to="/who-we-serve" replace />}
            />
            <Route path="/contact-us" element={<Contact />} />
            <Route
               path="/Contact"
               element={<Navigate to="/contact-us" replace />}
            />

         </Routes>
         <Footer />
      </Router>
   );
}
// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(<App />);
